module.exports = {
  home: {
    text1: '歡迎使用',
    text2: '本次登錄IP',
    text3: '本次登錄時間',
    text4: '上次登錄IP',
    text5: '上次登錄時間',
    text6: '最近一週數據統計',
    text7: '用戶註冊數',
    text8: '訂單數',
    text9: '本後臺系統由上海米因大數據科技開發團隊 技術支持',
  },
  admin: {
    t1: '菜單列表',
    t2: '新增菜單',
    t3: '修改菜單',
    t4: '菜單名稱',
    t5: '所屬一級菜單',
    t6: '圖標',
    t7: '路由',
    t8: '排序',
    t9: '是否顯示',
    t10: '編號',
    t11: '操作',
    t12: '英文名稱',
  },
  goods: {
    t1: '商品管理',
    t2: '添加商品',
    t3: '編號',
    t4: '商品圖',
    t5: '名稱',
    t6: '價格',
    t7: '市場價格',
    t8: '驗血價格',
    t9: '狀態',
    t10: '操作日期',
    t11: '操作',
    t12: '排序',
    t13: '歷史圖庫',
    t14: '添加',
    t15: '修改',
    t16: '請輸入',
    t17: '提交',
    t18: '取消',
    t19: '商品',
    t20: '圖片',
    t21: '請輸入名稱',
    t22: '請輸入價格',
    t23: '請輸入市場價格',
    t24: '代碼',
  },
  open: {
    a1: '該套餐僅適用於年齡在20~90週歲之間人群!',
    a2: '該套餐僅適用於年齡在40~80週歲之間人群!',

    t1: '個人信息',
    t2: '問卷信息',
    t3: '體型信息',
    t4: '生化信息',
    t5: '手機號',
    t6: '企業用戶ID',
    t7: '用戶性別',
    t8: '出生日期',
    t9: '報告單位',
    t10: '體檢日期',
    t11: '套餐內容',
    t12: '上一步',
    t13: '下一步',
    t14: '男',
    t15: '女',
    t16: '一、基本資料',
    t17: '1.客戶的居住地',
    t18: '2.客戶的喝酒情況（單選）？',
    t19: '3.客戶是否吸菸（單選）？',
    t20: '4.客戶的用餐習慣（單選）？',
    t21: '5.客戶是否是全日素食者（單選）？',
    t22: '6.客戶的運動習慣（單選）？',
    t23: '7.客戶是否有睡眠障礙（單選）？',
    t24: '8.客戶是否患有以下疾病？',
    t25: '9.客戶是否做過下列手術？',
    t26: '10.客戶的直系親屬有下列疾病嗎？',
    t27: '二、個人病史',
    t28: '三、個人手術史',
    t29: '四、家族病史',
    t30: '身高',
    t31: '體重',
    t311: '胸圍',
    t32: '腰圍',
    t33: '臀圍',
    t34: '體脂率',
    t35: '若不填體脂率,則根據您的信息自動生成',
    t36: '血壓檢查',
    t37: '血常規檢查',
    t38: '血糖檢查',
    t39: '血脂檢查',
    t40: '肝功能檢查',
    t41: '腎功能檢查',
    t42: '收縮壓(SBP)',
    t43: '舒張壓(DBP)',
    t44: '白細胞(WBC)',
    t45: '血紅蛋白(HGB)',
    t46: '血小板(PLT)',
    t47: '空腹血糖(FG)',
    t48: '糖化血紅蛋白(HBA1C)',
    t49: '總膽固醇(CHOL)',
    t50: '低密度脂蛋白(LDLC)',
    t51: '高密度脂蛋白(HDLC)',
    t52: '甘油三酯(TG)',
    t53: '穀草轉氨酶（GOT/AST）',
    t54: '谷丙轉氨酶（GPT/ALT）',
    t55: '鹼性磷酸酶(ALP)',
    t56: '血清白蛋白(ALB)',
    t57: '肌酐(CRE)',
    t58: '尿酸(UA)',
    t59: '腎小球濾過率(EGFR)',
    t60: '選填',
    t61: '確認提交',
    t62: '媽媽信息',
    t63: '寶寶信息',
    t64: '骨折問卷',
    t65: '套餐選擇',

    q1: '不喝',
    q2: '天天喝',
    q3: '經常喝',
    q4: '偶爾喝',
    q5: '不吸',
    q6: '天天吸',
    q7: '經常吸',
    q8: '偶爾吸',
    q9: '定時定量',
    q10: '不定時不定量',
    q11: '定時不定量',
    q12: '不定時但定量',
    q13: '不是',
    q14: '是',
    q15: '沒有或每週少於一小時',
    q16: '每週運動1~2小時',
    q17: '每週運動3~4小時',
    q18: '每週運動5~6小時',
    q19: '每週運動7小時以上',
    q20: '沒有',
    q21: '非常嚴重',
    q22: '經常',
    q23: '偶爾',
    q24: '否',
    q25: '是，請選擇服藥情況（多選）',
    q26: '疾病名稱',
    q27: '不服藥',
    q28: '偶爾服藥',
    q29: '經常服藥',
    q30: '是，請選擇（多選）',

    f1: '4.客戶曾經是否骨折（單選）？',
    f2: '5.客戶父母是否曾經髖部骨折（單選）？',
    f3: '6.客戶的日常生活與事務決定處理與認知能力？（單選）？',
    f4: '7.股骨頸骨密度（BMD）？',
    f5: '8.客戶是否患過以下疾病？',
    f6: '9.客戶是否需要醫護服務？',

    f7: '不知道',
    f8: '自主決定，一直且合理',
    f9: '部分自主，遇到新狀況會有困難',
    f10: '多數情況無法自主、或決定欠佳、或需提示',
    f11: '不知道',
    f12: '請填寫客戶曾經骨折次數',
    f13: '請輸入骨密度',
    f14: '請選擇客戶是否患有以下疾病',
    f15: '請選擇客戶的居住地',
    f16: '請選擇客戶的喝酒情況',
    f17: '請選擇客戶是否吸菸',
    f18: '請選擇客戶曾經是否存骨折',
    f19: '請選擇客戶父母是否曾經髖部骨折',
    f20: '請選擇客戶生活自主認知能力',
    f21: '請填寫客戶骨密度值',
    f22: '請填寫客戶曾經骨折次數',

    f23: '沒有',
    f24: '有',

    f25: '請輸入手機號',
    f26: '請輸入企業用戶ID',
    f27: '手機號與企業用戶ID至少填寫一項',
    f28: '請選擇',
    f29: '請選擇出生日期',
    f30: '請選擇體檢日期',
    f31: '體檢日期大於出生日期且不能大於當前時間',
    f32: '請選擇套餐',
    f33: '請選擇開通套餐',
    f34: '請選擇客戶的用餐習慣',
    f35: '請選擇客戶是否為全日素食者',
    f36: '請選擇客戶的運動習慣',
    f37: '請選擇客戶是否存在睡眠障礙',
    f38: '請選擇服藥情況',
    f39: '請填寫您的身高',
    f40: '請填寫您的體重',
    f41: '請輸入身高',
    f42: '請輸入體重',
    f43: '若不填腰圍,則根據您的信息自動生成',
    f44: '若不填臀圍,則根據您的信息自動生成',
    f45: '若不填體脂率,則根據您的信息自動生成',
    f46: '不能為空',
    f47: '請輸入（選填）',
    f48: '請輸入白細胞',
    f49: '請選擇客戶性別',
    f50: '請輸入腰圍',
    f51: '請輸入臀圍',
    f52: '請輸入胸圍',
    f53: '請填寫您的胸圍',

    f54: '身高為130~200',
    f55: '體重為30~160',
    f56: '胸圍為40~165',
    f57: '腰圍為40~150',
    f58: '臀圍為60~165',
    f59: '體脂率為3~75',

    f60: '確認輸入信息',
    f61:
      '您填寫的結果可能存在較大偏差，請您仔細核對該數值和所用單位是否正確並與您的報告一致。<br/>若您已經核對確認，並堅持以該結果進行提交和評估，我們可能會根據大數據算法對該結果進行一定程度上的修正和處理，以提供更合理的大數據評估結果和建議。',

    resetForm: '重选产品',
  },
  table: {
    t1: '編號',
    t2: '手機號/企業用戶ID',
    t3: '套餐內容',
    t4: '性別',
    t5: '出生日期',
    t6: '體檢時間',
    t7: '狀態',
    t8: '次數',
    t9: '操作',
    t10: '操作人',
    t11: '操作時間',
    t12: '開始日期',
    t13: '結束日期',
    t14: '全部套餐',
    t15: '開通日期',
    t16: '企業名稱',
    t17: '付費方式',
    t18: '使用次數',
    t19: '剩餘次數',
    t20: '查看詳情',
    t21: '姓名',
    t22: '免費',
    t23: '身份證號',
    t24: '套餐名稱',
    t25: '日期',
    t26: '後付費',
    t27: '預付費',
    t28: '消息',
    t29: '設置',
    t30: '退出',
    t31: '側邊欄皮膚',
    t32: '淺色',
    t33: '深色',
    t34: '總',
    t35: '共',

    t36: '已完成',
    t37: '未完成',
    t38: '修改',
    t39: '查詢',
    t40: '重置',
    t41: '查看',
    t42: '下載',

    t43: '請輸入手機號/企業用戶ID',

    t44: '開通',
    t45: '次',

    t46: '語言',
  },
  // area: {
  // 	c1: "江蘇省",
  // 	c2: "上海市",
  // 	c3: "北京市",
  // 	c4: "天津市",
  // 	c5: "浙江省",
  // 	c6: "廣東省",
  // 	c7: "遼寧省",
  // 	c8: "山東省",
  // 	c9: "內蒙古自治區",
  // 	c10: "重慶市",
  // 	c11: "福建省",
  // 	c12: "海南省",
  // 	c13: "湖北省",
  // 	c14: "湖南省",
  // 	c15: "陝西省",
  // 	c16: "河南省",
  // 	c17: "黑龍江省",
  // 	c18: "青海省",
  // 	c19: "雲南省",
  // 	c20: "安徽省",
  // 	c21: "四川省",
  // 	c22: "貴州省",
  // 	c23: "甘肅省",
  // 	c24: "江西省",
  // 	c25: "吉林省",
  // 	c26: "山西省",
  // 	c27: "河北省",
  // 	c28: "寧夏回族自治區",
  // 	c29: "廣西壯族自治區",
  // 	c30: "新疆維吾爾自治區",
  // 	c31: "西藏自治區",
  // 	c32: "中國臺灣",
  // 	c33: "中國香港",
  // },

  // 客戶居住地
  areaList: [
    { text: '江蘇省', code: '3200' },
    { text: '上海市', code: '3100' },
    { text: '北京市', code: '1100' },
    { text: '天津市', code: '1200' },
    { text: '浙江省', code: '3300' },
    { text: '廣東省', code: '4400' },
    { text: '遼寧省', code: '2100' },
    { text: '山東省', code: '3700' },
    { text: '重慶市', code: '5000' },
    { text: '福建省', code: '3500' },
    { text: '海南省', code: '4600' },
    { text: '湖北省', code: '4200' },
    { text: '湖南省', code: '4300' },
    { text: '陝西省', code: '6100' },
    { text: '河南省', code: '4100' },
    { text: '黑龍江省', code: '2300' },
    { text: '青海省', code: '6300' },
    { text: '雲南省', code: '5300' },
    { text: '安徽省', code: '3400' },
    { text: '四川省', code: '5100' },
    { text: '貴州省', code: '5200' },
    { text: '甘肅省', code: '6200' },
    { text: '江西省', code: '3600' },
    { text: '吉林省', code: '2200' },
    { text: '山西省', code: '1400' },
    { text: '河北省', code: '1300' },
    { text: '寧夏回族自治區', code: '6400' },
    { text: '廣西壯族自治區', code: '4500' },
    { text: '新疆維吾爾自治區', code: '6500' },
    { text: '內蒙古自治區', code: '1500' },
    { text: '西藏自治區', code: '5400' },
    { text: '中國臺灣', code: '0000' },
    { text: '中國香港', code: '4401' },
  ],

  diseases: {
    d1: '高血壓',
    d2: '高血脂',
    d3: '糖尿病',
    d4: '慢性肝病',
    d5: '慢性腎臟病',
    d6: '癌症',
    d7: '肝硬化',
    d8: '慢性阻塞性肺炎',
    d9: '關節炎',
    d10: '心臟病',
    d11: '腦中風',
    d12: '胃腸潰瘍',
    d13: '睡眠障礙',
    d14: '貧血',
    d15: '疼痛',
    d16: '哮喘',
    d17: '痛風',
    d18: '痔瘡',
    d19: '甲狀腺疾病',
  },
  oper: {
    d1: '頭或腦部',
    d2: '眼鼻耳',
    d3: '口腔、食道',
    d4: '胸部(心、肺等)',
    d5: '腹部(胃、肝、膽等)',
    d6: '關節與骨',
    d7: '婦科手術',
    d8: '泌尿系統',
  },
  famdis: {
    d1: '癌症',
    d2: '腦中風',
    d3: '心肌梗塞',
    d4: '肝硬化',
    d5: '老年失智',
    d6: '慢性阻塞性肺炎',
    d7: '結核病',
    d8: '先天畸形',
  },

  menus: localStorage.getItem('menusList')
    ? JSON.parse(localStorage.getItem('menusList'))
    : [],
}
